import { type FC } from 'react'
import { useIntl } from 'react-intl'
import { IconButton } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { getNavigationAndActionIcon } from '@DS/components/icons/navigationAndActionIcons'

import * as styles from './styles'

const CloseCircleIcon = getNavigationAndActionIcon('close_circle')

export type SheetHeaderProps = {
  onClose: VoidFunction
}

const SheetHeader: FC<SheetHeaderProps> = ({ onClose }) => {
  const theme = useTheme()
  const { formatMessage } = useIntl()

  return (
    <div css={styles.header(theme)}>
      <IconButton
        aria-label={formatMessage({ id: 'close' })}
        css={styles.headerIconButton(theme)}
        onClick={() => onClose()}
        data-test="sheet-close-button"
        size="large"
      >
        <CloseCircleIcon css={styles.headerCloseButton(theme)} />
      </IconButton>
    </div>
  )
}

export default SheetHeader
